// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WithDrawal_wrapper__3IQdd","flexWrapper":"WithDrawal_flexWrapper__3Ac-i","formWrapper":"WithDrawal_formWrapper__1V3gq","tableWrapper":"WithDrawal_tableWrapper__1sMrF"};